import { render } from "./admin-msg-list.vue?vue&type=template&id=331ca6f8"
import script from "./admin-msg-list.vue?vue&type=script&lang=js"
export * from "./admin-msg-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__